import { FC } from 'react'

import {
  MultiSelect as PrimaryMultiSelect,
  MultiSelectProps as PrimaryMultiSelectProps,
} from '@mantine/core'
import styled from 'styled-components'

import { colors } from 'src/Helpers/constants'

export type MultiSelectProps = PrimaryMultiSelectProps

const StyledMultiSelect = styled(PrimaryMultiSelect)`
  position: relative;
  width: 100%;

  input {
    min-height: 41px;
    color: ${colors.thirdBlue};
    --input-placeholder-color: ${colors.thirdBlue};

    &::placeholder {
      opacity: 0.5;
      font-size: 12px;
    }
  }

  label {
    position: absolute;
    top: -7px;
    left: 10px;
    z-index: 1;
    width: fit-content;
    background-color: white;
    padding: 0 5px;
    font-size: 10px;
    color: ${colors.thirdGray};
  }

  /* Style for selected values pills */
  .mantine-MultiSelect-pill {
    background-color: ${colors.mainBlue};
    color: white;
    border: none;

    .mantine-MultiSelect-pillRemove {
      color: white;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
  }

  &[data-error] input {
    border-color: ${colors.red};
  }

  &[data-error] {
    .mantine-MultiSelect-wrapper {
      margin-bottom: 0px !important;
    }
  }

  .mantine-MultiSelect-error {
    position: absolute;
    bottom: -15px;
    font-size: 11px;
    text-align: left;
  }

  .mantine-MultiSelect-pill {
    background-color: #f7f9fc;
    color: #4d6376;
  }
`

export const MultiSelect: FC<MultiSelectProps> = (props) => {
  return <StyledMultiSelect {...props} />
}
